<ng-container *ngIf="permConfig.isViewAllowed">
    <div class="container-fluid">
        <app-page-title title="ODA"></app-page-title>
        <form [formGroup]="odaChargesForm" (ngSubmit)="searchODA()" (keydown.enter)="useEnterKey ? $event.preventDefault() : searchODA()">
            <ngb-accordion #a="ngbAccordion" class="accordion range-accordion">
                <ngb-panel id="1">
                    <ng-template ngbPanelTitle class="text-black">
                        <i class="bx bx-search text-primary me-1"></i> Search and filter
                    </ng-template>
                    <ng-template ngbPanelContent>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-2" *ngIf="this.CustomerType == true">
                                    <div class="mb-2">
                                        <label class="form-label" for="customer">Customer</label>
                                        <ng-select id="customer" [items]="customerList" formControlName="ddlCustomer"
                                            bindLabel="name" [bindValue]="'id'" placeholder="Select" [appendTo]="'body'" [openOnEnter]="false"
                                            [ngClass]="{'is-invalid': (isFormSubmitted || odaChargesForm.get('ddlCustomer')?.touched) && odaChargesForm.get('ddlCustomer').errors}" appEnterDirective [onEnterKey]="useEnterKey" >
                                        </ng-select>
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="mb-2">
                                        <label class="form-label" for="vendor">Vendor</label>
                                        <ng-select id="vendor" [items]="vendorList" formControlName="ddlVendor"
                                            bindLabel="name" [bindValue]="'id'" placeholder="Select" [appendTo]="'body'" [openOnEnter]="false"(change)="bindService()"
                                            [ngClass]="{'is-invalid': (isFormSubmitted || odaChargesForm.get('ddlVendor')?.touched) && odaChargesForm.get('ddlVendor').errors}" appEnterDirective [onEnterKey]="useEnterKey" >
                                        </ng-select>
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="mb-2">
                                        <label class="form-label" for="service">Service</label>
                                        <ng-select id="service" [items]="serviceList" formControlName="ddlService"
                                            bindLabel="servicename" [bindValue]="'id'" placeholder="Select"
                                            [appendTo]="'body'" [openOnEnter]="false" appEnterDirective [onEnterKey]="useEnterKey">
                                        </ng-select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card mt-2">
                            <div class="card-header bg-transparent border-bottom text-uppercase">Destination</div>
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-md-2">
                                        <div class="mb-2">
                                            <label for="country" class="form-label">Country</label>
                                            <ng-select id="country" placeholder="Select" [appendTo]="'body'" [openOnEnter]="false"
                                                (change)="onCountryChange()" [items]="countryList" bindLabel="name"
                                                [bindValue]="'isocode'" formControlName="ddlCountry"
                                                [ngClass]="{'is-invalid': (isFormSubmitted || odaChargesForm.get('ddlCountry')?.touched) && odaChargesForm.get('ddlCountry').errors}">
                                            </ng-select>
                                        </div>
                                    </div>
                                    <div class="col-md-2">
                                        <div class="mb-2">
                                            <label for="state" class="form-label">State</label>
                                            <ng-select id="state" placeholder="Select" [appendTo]="'body'" [openOnEnter]="false"
                                                (change)="onStateChange()" [items]="stateList" bindLabel="name"
                                                [bindValue]="'isocode'" formControlName="ddlState">
                                            </ng-select>
                                        </div>
                                    </div>
                                    <div class="col-md-2">
                                        <div class="mb-2">
                                            <label for="city" class="form-label">City</label>
                                            <ng-select id="city" placeholder="Select" [appendTo]="'body'" [openOnEnter]="false" [items]="cityList"
                                                bindLabel="name" [bindValue]="'isocode'" formControlName="ddlCity">
                                            </ng-select>
                                        </div>
                                    </div>
                                    <div class="col-md-2">
                                        <div class="mb-2">
                                            <label for="pincode" class="form-label">Pincode</label>
                                                <input formControlName="txtPincode" type="text"
                                                    class="form-control col form-control-sm" placeholder="Type to search" [minlength]="minPincode" [maxlength]="maxPincode"
                                                    [ngbTypeahead]="searchPincode" [resultTemplate]="pt" [minlength]="minPincode" [maxlength]="maxPincode"
                                                    [inputFormatter]="pincodeFormatter" (ngModelChange)="onPincodeChanged()" (keydown)="setPincodeValidation()"
                                                    [ngClass]="{'is-invalid': (isFormSubmitted || odaChargesForm.get('txtPincode')?.touched) && odaChargesForm.get('txtPincode').errors}"/>
                                            <ng-template #pt let-p="result" let-t="term">
                                                <ngb-highlight [result]="p.pincode" [term]="t"></ngb-highlight>
                                                <!-- <span> | {{r['code']}}</span> -->
                                            </ng-template>
                                            <div *ngIf="(isFormSubmitted || odaChargesForm.get('txtPincode')?.touched) && odaChargesForm.get('txtPincode').errors"
                                                class="invalid-feedback">
                                                <span *ngIf="odaChargesForm.get('txtPincode').errors.pattern">Invalid Pincode.</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-2">
                                        <div class="mb-2">
                                            <label for="taxSwitch" class="form-label">ODA Applicable</label>
                                            <div class="form-check form-switch form-switch-md mb-2">
                                                <input type="checkbox" id="taxSwitch" class="form-check-input"
                                                    formControlName="txtODASwitch">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-2">
                                        <div class="mb-2">
                                            <label for="fuelSwitch" class="form-label">Serviceable</label>
                                            <div class="form-check form-switch form-switch-md mb-2">
                                                <input type="checkbox" id="fuelSwitch" class="form-check-input"
                                                    formControlName="txtServiceableSwitch">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </ngb-panel>
            </ngb-accordion>
            <div class="button-items mt-3">
                <button type="submit" class="btn btn-primary w-md">Search</button>
                <button type="button" class="btn btn-secondary w-md" (click)="resetForm()">Clear</button>
            </div>
        </form>
        <div class="row mt-3">
            <div class="card">
                <div class="card-header bg-transparent border-bottom text-uppercase">List</div>
                <div class="card-body">
                    <div class="col-md-12">
                        <div class="d-flex justify-content-between align-items-center mb-2">
                            <div class="d-flex">
                                <button type="button" class="btn btn-primary btn-sm d-flex" (click)="exportExcel()">Export
                                    <i class="bx bx-download font-size-16 px-1"></i>
                                </button>
                            </div>
                            <button type="button" class="btn btn-primary btn-sm">
                                <i class="mdi mdi-plus" (click)="openAddModel()" >Add</i>
                            </button>
                        </div>
                        <ag-grid-angular #agGrid style="width: 100%; height: 100%" id="myGrid" class="ag-theme-balham"
                            [rowData]="rowData" [columnDefs]="columnDefs" [animateRows]="true" [context]="context"
                            [gridOptions]="gridOptions" [defaultColDef]="defaultColDef" [suppressMenuHide]="true"
                            [pagination]="true" (gridReady)="onGridReady($event)">
                        </ag-grid-angular>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
</ng-container>
<ng-container *ngIf="!permConfig.isViewAllowed">
    <app-forbidden></app-forbidden>
</ng-container>
